export default __webpack_public_path__ + "static/media/Book11.0fbb0f98.pdf";